import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import DataCentreService from './pages/DataCentreService';
import NetworkService from './pages/NetworkService';
import SecurityService from './pages/SecurityService';
import HardwareService from './pages/HardwareService';
import ManagedITService from './pages/ManagedITService';
import StorageService from './pages/StorageService';
import DigitalWorkspaceService from './pages/DigitalWorkspaceService';
import HybridWorkspaceService from './pages/HybridWorkspaceService';
import FinancialService from './pages/FinancialService';
import WhyChooseUs from './pages/WhyChooseUs';
import Career from './pages/Career';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import './styles/global.css';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div style={{display: 'flex', flexDirection: 'column', minHeight: '100vh'}}>
        <Header />
        <main style={{flex: 1}}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/data-centre" element={<DataCentreService />} />
            <Route path="/services/network" element={<NetworkService />} />
            <Route path="/services/security" element={<SecurityService />} />
            <Route path="/services/hardware" element={<HardwareService />} />
            <Route path="/services/managed-it" element={<ManagedITService />} />
            <Route path="/services/storage" element={<StorageService />} />
            <Route path="/services/digital-workspace" element={<DigitalWorkspaceService />} />
            <Route path="/services/hybrid-workspace" element={<HybridWorkspaceService />} />
            <Route path="/services/financial" element={<FinancialService />} />
            <Route path="/why-choose-us" element={<WhyChooseUs />} />
            <Route path="/career" element={<Career />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
